import { Component, Vue, Prop as prop} from 'nuxt-property-decorator';
import VLazyImage from 'v-lazy-image';

@Component({
    components: {
        lazyImage: VLazyImage,
    },
})
export default class SimplePictureComponent extends Vue {
    @prop({required: true})
    public image: string;

    @prop({type: Boolean, default: false})
    public crop: boolean;

    @prop({type: Boolean, default: false})
    public original: boolean;

    @prop({required: true, type: Number})
    public width: number;

    @prop({required: true, type: Number})
    public height: number;

    @prop({
        default: function() {
            return [1];
        }
    })
    public scales: number[];

    get sources() {

        let result = [];

        let webp = [];
        let jpeg = [];

        for (let scale of this.scales) {

            const width = this.width*scale;
            const height = this.height*scale;

            let targetSize = `${width}x${height}`;
            if (this.original || width > 1920 || height > 1080) {
                targetSize = 'original';
            } else if (this.crop) {
                targetSize += 'xcrop';
            }

            webp.push(`/thumbs/${targetSize}/${this.image}.webp ${scale}x`);
            jpeg.push(`/thumbs/${targetSize}/${this.image}.jpeg ${scale}x`);
        }

        result.push({
            srcset: webp.join(', '),
            type: 'image/webp'
        });

        result.push({
            srcset: jpeg.join(', '),
            type: 'image/jpeg'
        });

    
        return result;
    }


    get defaultSrc() {
        if (this.original) {
            return `/thumbs/original/${this.image}.jpeg`;
        }
        return `/thumbs/${this.width}x${this.height}${this.crop ? 'xcrop' : ''}/${this.image}.jpeg`;
    }
}